import moment from 'moment';

export const getTimestampString = (time?: string | firebase.firestore.Timestamp) => (): string => {
    if (!time) return '';
    if (typeof time === 'string') return time;
    return moment(time.toDate()).format('DD/MM/YY HH:mm');
};
